import { post } from "./index";
export function upload(params) {
    
    return post('/api/public/upload', params, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
}